module.exports = __webpack_public_path__ + "img/nemereno.3d606722.svg";